import { format } from 'date-fns';
import { ETLExecutionModeEnum, ETLJobRecurrenceEnum, ScheduleETLJob } from '~/api/types';

const getScheduleAlertWording = (formValues: ScheduleETLJob): string | undefined => {
  if (formValues.execution_mode === ETLExecutionModeEnum.SCHEDULE) {
    if (!formValues.start_date || !formValues.time) return undefined;

    const startDate = format(
      new Date(formValues.start_date).setHours(
        Number(String(formValues.time).split(':')[0]) || 0,
        Number(String(formValues.time).split(':')[1]) || 0,
        0,
        0,
      ),
      "MMMM d, yyyy, 'at' h:mm a",
    );

    if (formValues.frequency === ETLJobRecurrenceEnum.NOT_REPEAT) {
      return `The ETL job is scheduled to run on ${startDate}.`;
    } else if (formValues.frequency === ETLJobRecurrenceEnum.DAILY) {
      return `The ETL job is scheduled to run daily starting ${startDate}.`;
    } else if (formValues.frequency === ETLJobRecurrenceEnum.WEEKLY) {
      return `The ETL job is scheduled to run weekly on ${format(new Date(formValues.start_date), 'EEEE')}s, starting ${startDate}.`;
    } else if (formValues.frequency === ETLJobRecurrenceEnum.MONTHLY) {
      return `The ETL job is scheduled to run on the ${format(new Date(formValues.start_date), 'do')} of every month, starting ${startDate}.`;
    }

    return undefined;
  }

  return 'The ETL job will be queued for immediate execution. It will start processing as soon as system resources become available.';
};

export default getScheduleAlertWording;
